import { useInView } from "@/hooks/useInView";
import { Clock, Calendar, ShieldCheck, Wallet } from "lucide-react";

const points = [
  {
    icon: Clock,
    title: "Pozwolenia to czas – mówimy o tym wprost",
    desc: "Uzyskanie wszystkich zgód administracyjnych trwa zazwyczaj od 8 do 24 miesięcy. Informujemy o tym z góry. Nie obiecujemy złotych gór z dnia na dzień.",
  },
  {
    icon: Calendar,
    title: "Kiedy zaczyna się wypłata czynszu",
    desc: "Czynsz wypłacamy od pierwszego dnia rozpoczęcia prac budowlanych – nie od daty podpisania umowy. To ważna różnica i mówimy o niej transparentnie.",
  },
  {
    icon: ShieldCheck,
    title: "Twoje bezpieczeństwo prawne",
    desc: "Umowa dzierżawy jest sporządzana przez radców prawnych i możesz ją skonsultować z własnym prawnikiem przed podpisaniem. Nie ma klauzul-pułapek.",
  },
  {
    icon: Wallet,
    title: "Ty nie płacisz absolutnie nic",
    desc: "Projekt, budowa, pozwolenia, obsługa administracyjna – 100% kosztów pokrywamy my. Twoja inwestycja finansowa wynosi dokładnie: zero złotych.",
  },
];

export default function Transparency() {
  const [ref, inView] = useInView();

  return (
    <section className="py-24 bg-slate-900" data-testid="transparency-section">
      <div className="max-w-7xl mx-auto px-6">
        <div
          ref={ref}
          className={`text-center mb-16 transition-all duration-700 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-emerald-400 text-sm font-semibold uppercase tracking-widest">
            Transparentność
          </span>
          <h2 className="text-4xl sm:text-5xl font-black text-white mt-2 tracking-tight">
            Stawiamy na uczciwość
          </h2>
          <p className="text-slate-400 text-lg mt-4 max-w-xl mx-auto">
            Bo zaufanie buduje się latami, a niszczy w chwili. Oto co
            powinieneś wiedzieć zanim podejmiesz decyzję.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          {points.map((pt, i) => (
            <TransparencyCard key={pt.title} pt={pt} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TransparencyCard({ pt, index }) {
  const [ref, inView] = useInView();
  const Icon = pt.icon;

  return (
    <div
      ref={ref}
      className={`bg-slate-800 rounded-2xl p-7 border border-slate-700 hover:border-emerald-700/50 transition-all duration-700 hover:-translate-y-1 ${
        inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      style={{ transitionDelay: `${index * 100}ms` }}
      data-testid={`transparency-card-${index + 1}`}
    >
      <div className="w-12 h-12 bg-emerald-900/60 border border-emerald-700/30 rounded-xl flex items-center justify-center mb-5">
        <Icon className="w-6 h-6 text-emerald-400" />
      </div>
      <h3 className="font-bold text-white text-lg mb-3">
        {pt.title}
      </h3>
      <p className="text-slate-300 text-sm leading-relaxed">{pt.desc}</p>
    </div>
  );
}
